import { gql } from '@apollo/client';

export const MatchupFields = gql`
  fragment MatchupFields on Matchup {
    id
    streamId
    order
    isMainEvent
    category
    rounds
    roundMinutes
    winnerCorner
    competitors {
      id
      matchupId
      corner
      name
      storeId
      store {
        id
        slug
        firstName
        lastName
        audience
        storeDetails {
          id
          storeName
          avatarURL
        }
      }
    }
  }
`;

export const MatchupVoteResultsFields = gql`
  fragment MatchupVoteResultsFields on MatchupVoteResults {
    matchupId
    total
    myVoteCompetitorId
    competitorVotes {
      competitorId
      votes
    }
  }
`;
